export const searchIdentifier = {
    ASSET_ID: 'asset_id',
    SEARCH_VIN: 'vin',
} as const;

export type SearchIdentifier = (typeof searchIdentifier)[keyof typeof searchIdentifier];
